import React, { useState, useEffect, useMemo } from 'react';
import './message.css';
import Feedback from '../feedbackComponent/feedback';
import Carrossel from '../localizacao-carrousel/carrossel';
import BuscaExames from '../buscaExamesComponent/BuscaExames';
import RemocaoExames from '../remocaoExamesComponent/RemocaoExames';
import Convenio from '../convenioComponent/Convenio';
import PerguntasApoio from '../perguntasApoioComponent/PerguntasApoio';
import ExamesAutorizacao from '../examesAutorizacaoComponent/ExamesAutorizacao';
import Pagamento from '../pagamentoComponent/Pagamento';
import ButtonLink from '../buttonLinkComponent/ButtonLink';
import { handleResetToHome } from '../../utils/buttonLink';
import LoadingExames from '../animatedLoadingComponent/LoadingExames';
import CalendarioAgendamento from '../calendarioAgendamentoComponent/CalendarioAgendamento';
import FlechaUnidades from '../../images/flecha.png';
import IconPDF from '../../images/icon-pdf.png';
import IconDownload from '../../images/download.png';
import { v4 as uuidv4 } from 'uuid';
import { sendClickLink, downloadPdfFromBase64Html, sendMessage, convertUriToLoginAction } from '../../functions/apiCalls/api';
import { bffExecuteInsuranceAction } from '../../functions/apiCalls/bffService';
import { TbConeOff } from 'react-icons/tb';

const ChatMessage = ({ message, handleButtonSetMessage, arrayMessage, indexMessage, uuid, client_id, setMessage, sendMessagePDF, messages, marca, origem, localizacao, operational_system, version_app, setRequestId, requestImage, requestId, isBookingTimeExpired }) => {

    const [selectedOption, setSelectedOption] = useState(null);
    const [uuidMessage, setuuidMessage] = useState(uuidv4());
    const [clickCounts, setClickCounts] = useState({});
    const [showAll, setShowAll] = useState(false);
    const [pdfSent, setPdfSent] = useState(false);
    const [perguntasCompletas, setPerguntasCompletas] = useState(false);
    // Compare questionnaire content, not array references from callback retries.
    const supportQuestionnaireIdentity = JSON.stringify(message?.perguntasApoio ?? null);
    const [convenioCompletado, setConvenioCompletado] = useState(false);
    const [expandedOptions, setExpandedOptions] = useState({});
    const [examesAutorizacaoCompletos, setExamesAutorizacaoCompletos] = useState(false);
    const [showDetalhesOcultos, setShowDetalhesOcultos] = useState(false);
    // Ref síncrona para impedir double-click/double-tap antes do re-render do React
    const optionClickedRef = React.useRef(false);
    // Ref do container desta instância — usado para garantir que o handler de link
    // só processe cliques dentro DESTA mensagem (evita N disparos com N instâncias)
    const containerRef = React.useRef(null);

    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        setCurrentPage(0);
    }, [message?.options]);

    // Procurar por examesSelecionados no histórico caso não esteja presente na mensagem atual
    const resolvedExamesSelecionados = useMemo(() => {
        if (message?.examesSelecionados) return message.examesSelecionados;
        if (Array.isArray(arrayMessage)) {
            for (let i = indexMessage; i >= 0; i--) {
                const msg = arrayMessage[i];
                if (msg && msg.examesSelecionados) {
                    return msg.examesSelecionados;
                }
            }
        }
        return null;
    }, [message?.examesSelecionados, arrayMessage, indexMessage]);

    // Remove o placeholder detalhesOcultosTag da resposta antes de renderizar
    const cleanedResponse = typeof message?.response === 'string' && typeof message?.detalhesOcultosTag === 'string' && message.detalhesOcultosTag !== ''
        ? message.response.split(message.detalhesOcultosTag).join('')
        : message?.response;

    // Exibe o bloco de detalhes ocultos se o placeholder estiver presente nessa mensagem
    const hasDetalhesPlaceholder = Array.isArray(message?.detalhesOcultos) &&
        message.detalhesOcultos.length > 0 &&
        typeof message?.detalhesOcultosTag === 'string' &&
        message.detalhesOcultosTag !== '' &&
        typeof message?.response === 'string' &&
        message.response.includes(message.detalhesOcultosTag);

    // Partes do texto antes e depois do placeholder para renderização inline
    const [responseBeforePlaceholder, responseAfterPlaceholder] = hasDetalhesPlaceholder
        ? [message.response.split(message.detalhesOcultosTag)[0], message.response.split(message.detalhesOcultosTag)[1] || '']
        : [null, null];

    // Aciona OCR da carteirinha ao selecionar um convênio específico (sem empresa/plano)
    const handleConvenioFastOCR = (convenioId, convenioName) => {
        setConvenioCompletado(true);
        const typing = { origin: 'bot', response: 'Digitando...', options: [], typing: true };
        setMessage(messages => [...messages, typing]);

        const insuranceSelected = {
            insurance: { id: String(convenioId || ''), name: String(convenioName || '') },
            isManual: false
        };

        sendMessage(
            setMessage,
            client_id,
            'ocr-carteirinha',
            messages,
            marca,
            origem,
            null,
            null,
            localizacao?.lat || null,
            localizacao?.long || null,
            null,
            () => {},
            () => {},
            operational_system || 'web',
            version_app || '1.0.0',
            message?.examesSelecionados || null,
            null,
            requestImage,
            setRequestId,
            insuranceSelected
        );
    };

    // Função helper para verificar se há perguntas válidas (NOMINAL, QUANTITATIVO ou LATERALIDADE)
    const hasValidPerguntas = (perguntasApoio) => {
        if (!perguntasApoio || !Array.isArray(perguntasApoio) || perguntasApoio.length === 0) return false;
        return perguntasApoio.some((pergunta) => {
            if (!pergunta || !pergunta.validacoes) return false;
            // NOMINAL com opções
            if (
                pergunta.tipo === 'NOMINAL' &&
                Array.isArray(pergunta.validacoes.opcoesValidas) &&
                pergunta.validacoes.opcoesValidas.length > 0
            ) {
                return true;
            }
            // QUANTITATIVO com min ou max
            if (
                pergunta.tipo === 'QUANTITATIVO' &&
                (pergunta.validacoes.minimo !== undefined || pergunta.validacoes.maximo !== undefined)
            ) {
                return true;
            }
            // LATERALIDADE com opções
            if (
                pergunta.tipo === 'LATERALIDADE' &&
                Array.isArray(pergunta.validacoes.opcoesValidas) &&
                pergunta.validacoes.opcoesValidas.length > 0
            ) {
                return true;
            }
            return false;
        });
    };

    // Função para lidar com o completion das perguntas de apoio
    const handlePerguntasApoioComplete = (respostasFormatadas) => {
        console.log('Perguntas de apoio finalizadas:', respostasFormatadas);
        
        // Marcar perguntas como completas
        setPerguntasCompletas(true);
        
        // Adicionar mensagem de "Digitando..." antes de enviar
        const typing = { origin: 'bot', response: 'Digitando...', options: [], typing: true };
        setMessage(messages => [...messages, typing]);

        // Enviar as respostas para a API através do contexto
        const contextWithRespostas = {
            context: {
                localizacao,
                operational_system: operational_system || 'web',
                version_app: version_app || '1.0.0',
                perguntasApoio: respostasFormatadas // Enviar as respostas no contexto
            }
        };

        // Fazer a chamada para a API
        sendMessage(
            setMessage, 
            client_id, 
            '', // Mensagem vazia pois as respostas estão no contexto
            messages, 
            marca, 
            origem, 
            null, // teste 
            null, // localizacao
            localizacao?.lat || null, 
            localizacao?.long || null, 
            null, // lastInput
            () => {}, // setTeste2
            () => {}, // getLocation 
            operational_system || 'web', 
            version_app || '1.0.0',
            message?.examesSelecionados || null, // examesSelecionados
            contextWithRespostas, // Passar o contexto com as respostas
            requestImage, // requestImage
            setRequestId // setRequestId
        );
    };

    // Finalização do componente de Exames de Autorização (enviar CRM/UF por exame)
    const handleExamesAutorizacaoComplete = async (respostas) => {
        setExamesAutorizacaoCompletos(true);
        const typing = { origin: 'bot', response: 'Digitando...', options: [], typing: true };
        setMessage(messages => [...messages, typing]);

        try {
            const url = process.env.REACT_APP_INSURANCE_API_URL;
            const apiKey = process.env.REACT_APP_INSURANCE_API_KEY;

            const requests = respostas.map(async (r) => {
                const context = {
                    action: 'getDoctorHealthBookingAction',
                    crmNumber: String(r.crm),
                    state: String(r.uf).toUpperCase(),
                    documentType: 'CRM'
                };

                if (process.env.REACT_APP_BFF_API_URL || !apiKey) {
                    try {
                        const json = await bffExecuteInsuranceAction(context, '');
                        return { ok: true, status: 200, json, original: r };
                    } catch (e) {
                        return { ok: false, status: 500, json: null, original: r };
                    }
                }

                const body = {
                    context,
                    code_execute: ''
                };
                return fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': apiKey
                    },
                    body: JSON.stringify(body)
                }).then(async (resp) => ({ ok: resp.ok, status: resp.status, json: resp.ok ? await resp.json() : null, original: r }));
            });

            const results = await Promise.allSettled(requests);

            const toIsoDate = (ddmmyyyy) => {
                const m = (ddmmyyyy || '').match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
                if (!m) return (ddmmyyyy || '');
                const [_, dd, mm, yyyy] = m;
                return `${yyyy}-${mm}-${dd}`;
            };

            // Montar dataAuthorization agrupando por médico e metadados
            const items = results.map((res) => {
                const original = res.status === 'fulfilled' ? res.value.original : null;
                const ok = res.status === 'fulfilled' ? res.value.ok : false;
                const payload = res.status === 'fulfilled' ? res.value.json : null;
                const foundDoctorId = ok ? (payload?.context?.doctor?.doctorId) : null;
                const doctorNotFound = !(ok && foundDoctorId);
                return {
                    examId: String(original?.id || ''),
                    doctorId: doctorNotFound ? '' : String(foundDoctorId),
                    requestDate: String(original?.requestDate || ''),
                    cidCode: String(original?.cidCode || '').toUpperCase(),
                    diagnosisHypothesis: String(original?.diagnosisHypothesis || ''),
                    notes: String(original?.notes || ''),
                    doctorNotFound
                };
            }).filter(i => i.examId);

            const groupedMap = new Map();
            for (const it of items) {
                const key = [it.doctorId, it.doctorNotFound ? '1' : '0', toIsoDate(it.requestDate), it.cidCode, it.diagnosisHypothesis, it.notes].join('|');
                if (!groupedMap.has(key)) {
                    groupedMap.set(key, {
                        doctorId: it.doctorId,
                        requestDate: toIsoDate(it.requestDate),
                        cidCode: it.cidCode,
                        diagnosisHypothesis: it.diagnosisHypothesis,
                        notes: it.notes,
                        examIds: [it.examId],
                        doctorNotFound: it.doctorNotFound
                    });
                } else {
                    groupedMap.get(key).examIds.push(it.examId);
                }
            }
            const dataAuthorization = Array.from(groupedMap.values());

            const contextWithRespostas = {
                context: {
                    localizacao,
                    operational_system: operational_system || 'web',
                    version_app: version_app || '1.0.0',
                    dataAuthorization
                }
            };

            sendMessage(
                setMessage,
                client_id,
                '',
                messages,
                marca,
                origem,
                null,
                null,
                localizacao?.lat || null,
                localizacao?.long || null,
                null,
                () => {},
                () => {},
                operational_system || 'web',
                version_app || '1.0.0',
                message?.examesSelecionados || null,
                contextWithRespostas,
                requestImage,
                setRequestId
            );
        } catch (e) {
            const contextWithRespostas = {
                context: {
                    localizacao,
                    operational_system: operational_system || 'web',
                    version_app: version_app || '1.0.0',
                    examesAutorizacao: respostas
                }
            };
            sendMessage(
                setMessage,
                client_id,
                '',
                messages,
                marca,
                origem,
                null,
                null,
                localizacao?.lat || null,
                localizacao?.long || null,
                null,
                () => {},
                () => {},
                operational_system || 'web',
                version_app || '1.0.0',
                message?.examesSelecionados || null,
                contextWithRespostas,
                requestImage,
                setRequestId
            );
        }
    };

    // Handler para confirmar convênio/empresa/plano + carteirinha
    const handleConvenioConfirm = (dados) => {
        setConvenioCompletado(true);

        const typing = { origin: 'bot', response: 'Digitando...', options: [], typing: true };
        setMessage(messages => [...messages, typing]);

        // Monta objeto padronizado para o backend
        const insuranceSelected = {
            insurance: { id: String(dados?.ids?.convenio || ''), name: String(dados?.convenio || '') },
            company: { id: String(dados?.ids?.empresa || ''), name: String(dados?.empresa || '') },
            plan: { id: String(dados?.ids?.plano || ''), name: String(dados?.plano || '') },
            card: { 
                number: String(dados?.carteirinhaNumero || ''),
                ValidThru: String(dados?.carteirinhaValidThru || '')
            },
            isManual: true
        };

        sendMessage(
            setMessage,
            client_id,
            '',
            messages,
            marca,
            origem,
            null,
            null,
            localizacao?.lat || null,
            localizacao?.long || null,
            null,
            () => {},
            () => {},
            operational_system || 'web',
            version_app || '1.0.0',
            resolvedExamesSelecionados,
            null,
            requestImage,
            setRequestId,
            insuranceSelected
        );
    };

    const handleButtonLinkClick = () => {
        const text = message?.buttonLinkText || message?.response || '';
        if (!text) return;
        handleButtonSetMessage(text);
    };

    // Handler para quando o usuário optar por atendimento particular a partir do componente de convênio
    const handleConvenioGoToParticular = () => {
        const typing = { origin: 'bot', response: 'Digitando...', options: [], typing: true };
        setMessage(messages => [...messages, typing]);

        sendMessage(
            setMessage,
            client_id,
            'convênio-para-particular',
            messages,
            marca,
            origem,
            null,
            localizacao,
            localizacao?.lat || null,
            localizacao?.long || null,
            null,
            () => {},
            () => {},
            operational_system || 'web',
            version_app || '1.0.0',
            message?.examesSelecionados || null,
            null,
            requestImage,
            setRequestId
        );
    };

    useEffect(() => {
        if (!pdfSent &&
            message?.response &&
            (message.response.includes("Pronto! O exame contém imagem") ||
                message.response.includes("Pronto! O exame contém video") ||
                message.response.includes("Pronto! O exame com imagem") ||
                message.response.includes("Pronto! O exame com vídeo"))) {
            sendMessagePDF();
            setPdfSent(true);
        }
    }, [message?.response, sendMessagePDF, pdfSent]);

    // Reset only for a different questionnaire, preserving completed historical bubbles.
    useEffect(() => {
        setPerguntasCompletas(false);
    }, [supportQuestionnaireIdentity]);

    // Resetar estado showAll quando chegar mensagem com respostaExtensa
    useEffect(() => {
        if (message?.respostaExtensa) {
            setShowAll(false); // Resetar estado para forçar re-renderização
        }
    }, [message?.response, message?.respostaExtensa]);

    // Resetar estado das opções selecionadas caso a mensagem seja do menu inicial ou quando reiniciada
    useEffect(() => {
        if (!message?.buttonClicked && !arrayMessage.some(m => m?.origin === 'you')) {
            setSelectedOption(null);
            optionClickedRef.current = false;
        }
    }, [message?.response, message?.isFirstMessage, message?.buttonClicked, arrayMessage.length]);

    const verificaResposta = (index, text) => {
        // Proteção síncrona contra double-click/double-tap:
        // useRef é atualizado antes do próximo render, diferente de useState.
        if (optionClickedRef.current) return;
        optionClickedRef.current = true;
        setSelectedOption(index);
        handleButtonSetMessage(text);
        message.bloqueiaInput = false;
        // Marcar mensagem como respondida para desabilitar botões anteriores
        message.buttonClicked = true;
    };

    const sendInputToLLM = (url) => {
        sendMessagePDF()
        window.open(url)
    }

    // Função para extrair URL de um link HTML
    const extractUrlFromHtml = (htmlString) => {
        const match = htmlString.match(/href="([^"]+)"/);
        return match ? match[1] : null;
    };

    // Função para tratar botões do tipo text-with-button
    const handleTextWithButton = (option) => {
        const url = extractUrlFromHtml(option.text);
        if (url) {
            window.open(url, '_blank');
        }
    };

    const toggleOptionDetails = (event, index) => {
        // Evita que o clique no link de detalhes envie a opção
        event.preventDefault();
        event.stopPropagation();
        setExpandedOptions(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    // Função para lidar com o clique em um botão que tem PDF em base64
    const handlePdfButtonClick = (event, optionText) => {
        event.preventDefault();

        // Verificar se o texto contém base64 de PDF
        if (optionText && optionText.includes('data:application/pdf;base64,')) {
            // Nome do arquivo com timestamp para evitar colisões
            const fileName = `documento_${new Date().toISOString().replace(/[:.]/g, '-')}.pdf`;

            // Iniciar download com log para ajudar no diagnóstico
            console.log("Iniciando download de PDF a partir do botão");
            console.log("Tamanho do conteúdo do botão:", optionText.length);

            // Criar uma versão de depuração mais curta para o log
            const optionPreview = optionText.length > 100
                ? `${optionText.substring(0, 50)}...${optionText.substring(optionText.length - 50)}`
                : optionText;
            console.log("Prévia do conteúdo:", optionPreview);

            // Iniciar download
            const success = downloadPdfFromBase64Html(optionText, fileName);

            if (success) {
                // Opcionalmente, marcar o botão como selecionado
                setSelectedOption(event.currentTarget.getAttribute('data-option-index'));

                // Informar ao usuário sobre sucesso
                console.log("Solicitação de download enviada com sucesso");
            } else {
                console.error("Falha ao iniciar o download do PDF");
            }
        } else {
            console.error("O botão não contém dados PDF válidos");
        }
    };

    useEffect(() => {
        if (!message?.response) return;

        const handleLinkClick = (event) => {
            // Usa closest('a') para garantir que mesmo cliques em filhos do <a> (textos, spans)
            // resolvam para o próprio elemento âncora e seu atributo href
            const anchor = event.target.closest('a');

            // Guarda: só processar se o clique ocorreu DENTRO do container desta instância.
            // Sem isso, cada instância de ChatMessage registra seu handler no document,
            // causando N disparos por clique com N mensagens renderizadas.
            if (!anchor) return;
            if (containerRef.current && !containerRef.current.contains(event.target)) return;

            const href = anchor.getAttribute('href');
            let origin = "";

            // Intercepta links tel: na origem area_logada para garantir funcionamento
            // mesmo dentro de iframe (alguns browsers bloqueiam tel: em iframes)
            if (href && href.startsWith('tel:') && origem === 'area_logada') {
                event.preventDefault();
                // Abre o link tel: via window.open com _top para ultrapassar o iframe
                // → Mobile: abre o diálogo nativo "Ligar X / Cancelar"
                // → Desktop: abre o diálogo do browser "Abrir Selecionar um aplicativo?"
                window.open(href, '_blank');
                return;
            }

            // Helper para identificar links de resultados
            const isResultsLink = (url) => {
                if (!url) return false;
                const lowerUrl = url.toLowerCase();
                const lowerResponse = (message?.response || '').toLowerCase();
                return (
                    lowerUrl.includes('resultados') ||
                    lowerUrl.includes('resultadosexame') ||
                    lowerResponse.includes('para acessar seus resultados')
                );
            };

            // Intercepta links externos (http/https) na origem area_logada para
            // redirecionar o usuário de forma autenticada via ConvertUriToLoginAction.
            // Exceção: links de resultados de exames devem manter o link original.
            if (
                href &&
                (href.startsWith('http://') || href.startsWith('https://')) &&
                origem === 'area_logada' &&
                !isResultsLink(href)
            ) {
                event.preventDefault();
                console.log('🔐 Link externo detectado em area_logada, convertendo para URL autenticada:', href);

                // Chamar a API de forma assíncrona sem bloquear o handler
                (async () => {
                    const redirectUrl = await convertUriToLoginAction(client_id);
                    if (redirectUrl) {
                        console.log('✅ Abrindo URL autenticada:', redirectUrl);
                        window.open(redirectUrl, '_blank');
                    } else {
                        // Fallback: abrir a URL original caso a API falhe
                        console.warn('⚠️ Fallback: abrindo URL original:', href);
                        window.open(href, '_blank');
                    }
                })();
                return;
            }

            // Remove as tags HTML do message.response
            const fullText = message.response.replace(/<[^>]*>/g, '');

            if (fullText.includes("Para consultar os exames disponíveis")) {
                origin = "AD - Agendar exames"
            } else if (fullText.includes("Para reagendar procedimentos")) {
                origin = "AD - Reagendar exames"
            } else if (fullText.includes("Você pode ver informações sobre vacinas")) {
                origin = "AD - Vacinas"
            } else if (fullText.includes("Você pode agendar")) {
                origin = "AD - Consultar Agendamentos"
            } else if (fullText.includes("Para conferir valores e até agendar online")) {
                origin = "AD - Orçamentos"
            } else if (fullText.includes("Desculpe, não conseguimos encontrar uma resposta")) {
                origin = "Central - Sem resposta"
            } else if (fullText.includes("Entendemos que questões sobre diversidade")) {
                origin = "Central - Diversidade"
            } else if (fullText.includes("Entendemos que questões de acessibilidade são de")) {
                origin = "Central - Acessibilidade"
            } else if (fullText.includes("Pelo site https://agendamento.amaissaude.com.br/")) {
                origin = "SITE AD - Consulta de agendamentos"
            } else if (fullText.includes("Para acessar os resultados dos seus exames, recomendamos que você entre em contato")) {
                origin = "Central - Resultados de exames"
            } else if (fullText.includes("Esses são os agendamentos mais próximos encontrados")) {
                origin = "APP - Consulta preparo de exames"
            } else if (fullText.includes("O procedimento de vacinas pode estar disponível nas unidades")) {
                origin = "AD - Unidades"
            }

            setClickCounts((prev) => ({
                ...prev,
                [href]: (prev[href] || 0) + 1,
            }));

            sendClickLink(client_id, href, uuidMessage, origin);
        }

        // Usa event delegation no document para capturar cliques em qualquer <a>,
        // incluindo os renderizados dinamicamente via dangerouslySetInnerHTML
        document.addEventListener('click', handleLinkClick);

        // Cleanup: remove o event listener quando o componente for desmontado
        return () => {
            document.removeEventListener('click', handleLinkClick);
        };
    }, [message?.response, uuidMessage, client_id, origem]);

    // Verificar se há alguma mensagem posterior com botão clicado
    const hasNewerButtonClicked = arrayMessage.slice(indexMessage + 1).some(m => m?.buttonClicked === true);

    // Verificar se há algum buttonLink mais novo; assim mantemos apenas o último "voltar"
    const hasNewerButtonLink = arrayMessage.slice(indexMessage + 1).some(m => m?.buttonLink === true);

    // Verificar se o usuário já enviou alguma mensagem depois desta
    const hasNewerUserMessage = arrayMessage.slice(indexMessage + 1).some(m => m?.origin === 'you');

    // Carregamentos automáticos também devem esconder o retorno, mesmo sem mensagem do usuário.
    const isChatLoading = arrayMessage.some(m =>
        m?.typing === true || (m?.origin === 'bot' && m?.response === 'Digitando...')
    );
    const showButtonLink = message?.buttonLink === true && !!message?.buttonLinkText &&
        !hasNewerButtonLink && !hasNewerUserMessage && !isChatLoading;

    // Verificar se o usuário já interagiu no chat ou se a mensagem é um passo subsequente
    const hasUserInteracted = arrayMessage.some(m => m?.origin === 'you' || m?.buttonClicked === true);
    const isInitialMessage = !hasUserInteracted && (indexMessage === 0 || message?.isFirstMessage);
    const hasNewerBotMessage = arrayMessage.slice(indexMessage + 1).some(m => m?.origin === 'bot' && !m?.typing);

    // showHomeLink: presente em todos os passos exceto no menu inicial.
    // Oculto durante carregamento (Digitando...) ou se o usuário já enviou nova mensagem.
    const showHomeLink = (showButtonLink || (!isInitialMessage && hasUserInteracted && !hasNewerBotMessage)) &&
        !hasNewerUserMessage && !isChatLoading && !message?.isRestartButton && !message?.isHistoryBanner && !message?.endSession;

    // Banner especial de histórico de conversa retomada
    if (message?.isHistoryBanner) {
        if (origem === 'area_logada') {
            const dateStr = message.historyDate || new Date().toLocaleDateString('pt-BR');

            return (
                <div className="history-banner area-logada">
                    <svg className="history-icon" viewBox="0 0 50 50" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                        <g clipPath="url(#clip0_2028_26094_custom)">
                            <path d="M50 25C50 38.8086 38.8086 50 25 50C11.1914 50 0 38.8086 0 25C0 19.7949 1.58984 14.9609 4.31152 10.957C4.79688 10.2441 5.76856 10.0586 6.48145 10.5469C7.19531 10.9473 7.38086 12.002 6.89551 12.7148C4.51562 16.2207 3.125 20.4492 3.125 25C3.125 37.0801 12.9199 46.875 25 46.875C37.0801 46.875 46.875 37.0801 46.875 25C46.875 13.4473 37.9102 3.98145 26.5625 3.17969V10.9375C26.5625 11.7969 25.8594 12.5 25 12.5C24.1406 12.5 23.4375 11.7969 23.4375 10.9375V1.5625C23.4375 0.699609 24.1406 0 25 0C38.8086 0 50 11.1914 50 25ZM26.1035 23.8965C26.7187 24.502 26.7187 25.498 26.1035 26.1035C25.498 26.7187 24.502 26.7187 23.8965 26.1035L14.5215 16.7285C13.9062 16.123 13.9062 15.127 14.5215 14.5215C15.127 13.9062 16.123 13.9062 16.7285 14.5215L26.1035 23.8965Z" fill="currentColor"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_2028_26094_custom">
                                <rect width="50" height="50" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <span>
                        <strong>{dateStr}</strong> - Continuando sua conversa anterior
                    </span>
                </div>
            );
        }

        return (
            <div className="history-banner">
                <span dangerouslySetInnerHTML={{ __html: message.response }} />
            </div>
        );
    }

    // Botão avulso de Reiniciar Atendimento (sem balão de mensagem)
    if (message?.isRestartButton) {
        // Se o usuário interagiu (enviou uma nova mensagem), o botão deixa de ser a última mensagem e sumirá.
        if (indexMessage !== arrayMessage.length - 1 || isChatLoading) return null;

        return (
            <div className="button-link-wrapper restart-history" style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '25px', marginBottom: '15px', clear: 'both' }}>
                <ButtonLink
                    text={message.buttonLinkText || 'Reiniciar Atendimento'}
                    onClick={() => handleButtonSetMessage(message.buttonLinkText || 'Reiniciar Atendimento')}
                />
            </div>
        );
    }

    if (message?.origin === 'bot' && message?.options && message?.options.length > 0) {
        // Verifica se a feature flag do calendário está ativa
        const isCalendarEnabled = 
            window.currentFeatureFlags?.flags?.calendar?.enabled === true || 
            window.currentFeatureFlags?.calendar?.enabled === true;

        // Verifica se é uma mensagem de agendamento (contém datas no formato DD/MM)
        const isCalendario = isCalendarEnabled && message.options.some(opt => /\(\d{2}\/\d{2}\)/.test(opt.text.replace(/<[^>]+>/g, '')) && /\d{2}:\d{2}/.test(opt.text.replace(/<[^>]+>/g, '')));

        if (isCalendario) {
            return (
                <>
                    <div className={`message ${message.origin}`}>
                        <div className={`message-content`}>
                            {hasDetalhesPlaceholder ? (
                                <>
                                    <div dangerouslySetInnerHTML={{ __html: responseBeforePlaceholder }} />
                                    {showDetalhesOcultos && (
                                        <div className="detalhes-ocultos-content">
                                            {message.detalhesOcultos.map((item, idx) => (
                                                <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
                                            ))}
                                        </div>
                                    )}
                                    {responseAfterPlaceholder && (
                                        <div dangerouslySetInnerHTML={{ __html: responseAfterPlaceholder }} />
                                    )}
                                    <button
                                        className="ver-exames-btn"
                                        onClick={() => setShowDetalhesOcultos(prev => !prev)}
                                    >
                                        {showDetalhesOcultos ? 'Ocultar detalhes' : 'Ver detalhes'}
                                    </button>
                                </>
                            ) : (
                                <>
                                    <div dangerouslySetInnerHTML={{
                                        __html: message.respostaExtensa || showAll || cleanedResponse.length <= 300
                                            ? cleanedResponse
                                            : cleanedResponse.substring(0, 269) + '...'
                                    }} />
                                    {!message.respostaExtensa && cleanedResponse.length > 300 && (
                                        <button
                                            className="show-more-btn"
                                            onClick={() => setShowAll(!showAll)}
                                        >
                                            <strong>{showAll ? 'Ver menos' : 'Ver mais'}</strong>
                                        </button>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                    <CalendarioAgendamento 
                        message={message} 
                        verificaResposta={verificaResposta}
                        hasNewerUserMessage={hasNewerUserMessage}
                        showButtonLink={showButtonLink}
                        showHomeLink={showHomeLink}
                    />
                </>
            );
        }

        // Separa botões de voltar/navegação para que sempre fiquem no final do container
        const optionsWithIndex = message.options.map((option, index) => ({ option, index }));
        const isBackOptionText = text => text.includes('⬅') || text.includes('←') || text.toLowerCase().includes('voltar');
        const backButtons = optionsWithIndex.filter(item => item.option?.text && isBackOptionText(item.option.text));
        const standardOptions = optionsWithIndex.filter(item => !(item.option?.text && isBackOptionText(item.option.text)));

        const isSchedulingMessage = message.options.some(opt => /\(\d{2}\/\d{2}\)/.test(opt.text.replace(/<[^>]+>/g, '')) && /\d{2}:\d{2}/.test(opt.text.replace(/<[^>]+>/g, '')));        
        // Horários vindos do agente LLM (available-slots): renderizados como chips em grade
        const hasTimeButtons = message.options.some(opt => opt.type === 'time-button');
        // Separa os chips de horário das demais opções (ex.: "Outros horários"),
        // que devem permanecer sempre visíveis. Usado apenas na nova funcionalidade LLM.
        const isSlotOption = ({ option }) => {
            if (option.type === 'time-button') return true;
            const t = option.text.replace(/<[^>]+>/g, '');
            return /\(\d{2}\/\d{2}\)/.test(t) && /\d{2}:\d{2}/.test(t);
        };
        const slotOptions = hasTimeButtons ? standardOptions.filter(isSlotOption) : [];
        const nonSlotOptions = hasTimeButtons ? standardOptions.filter(item => !isSlotOption(item)) : [];

        // Nova funcionalidade LLM (hasTimeButtons): paginação em janela — mostra 4 horários por
        // vez e SUBSTITUI (não acumula) os que estão na tela a cada clique, com botões "Ver mais
        // horários" e "Ver anteriores". Sem nova chamada/balão. O formato antigo
        // (isSchedulingMessage) já usa a mesma paginação em janela.
        const SLOTS_PER_PAGE = 4;
        // Total de grupos calculado localmente a partir dos horários já recebidos (sem nova chamada)
        const totalSlotPages = Math.ceil(slotOptions.length / SLOTS_PER_PAGE);
        const visibleOptions = hasTimeButtons
            ? slotOptions.slice(currentPage * SLOTS_PER_PAGE, (currentPage + 1) * SLOTS_PER_PAGE)
            : (isSchedulingMessage ? standardOptions.slice(currentPage * 4, (currentPage + 1) * 4) : standardOptions);
        const showMoreBtn = hasTimeButtons
            ? slotOptions.length > (currentPage + 1) * SLOTS_PER_PAGE
            : (isSchedulingMessage && standardOptions.length > 4);
        // Botão "Ver anteriores": só na nova funcionalidade LLM e quando não está na primeira página
        const showPrevBtn = hasTimeButtons && currentPage > 0;


        const handleNextOptions = () => {
            if (hasTimeButtons) {
                setCurrentPage(prev => prev + 1);
                return;
            }

            const totalPages = Math.ceil(standardOptions.length / 4);
            setCurrentPage(prev => (prev + 1) % totalPages);
        };

        const handlePrevOptions = () => {
            setCurrentPage(prev => Math.max(0, prev - 1));
        };


        const renderOption = (option, index) => {
            if (option.type === 'text-with-button') {
                // Apenas flows que declaram esta flag não renderizam a âncora.
                // Os demais botões preservam exatamente o comportamento legado.
                const buttonText = option.openExternalDirectly
                    ? option.text.replace(/<a\b[^>]*>([\s\S]*?)<\/a>/gi, '$1')
                    : option.text;
                return (
                    <button
                        onClick={() => handleTextWithButton(option)}
                        key={index}
                        className={`option-button ${hasNewerButtonClicked ? 'disabled' : ''}`}
                        data-trusted-element="true"
                        data-option-index={index}
                        data-option-type="text-with-button"
                        disabled={hasNewerButtonClicked}
                    >
                        <span dangerouslySetInnerHTML={{ __html: buttonText }} />
                    </button>
                );
            } else {
                const hasDetails = Boolean(option.details);
                const isExpanded = Boolean(expandedOptions[index]);
                const isConfirmButton = option?.text && typeof option.text === 'string' && !!option.text.match(/confirmar.*agendamento/i);
                const isDisabled = hasNewerButtonClicked || (selectedOption !== null) || (isConfirmButton && isBookingTimeExpired);
                const isBackButton = option?.text && (option.text.includes('⬅') || option.text.includes('←'));

                return (
                    <button
                        onClick={() => verificaResposta(index, option.text)}
                        key={index}
                        className={`option-button ${hasDetails ? 'has-details' : ''} ${option.type === 'split-button' ? 'split-button' : ''} ${selectedOption === index ? 'selected' : isDisabled ? 'disabled' : ''} ${isBackButton ? 'option-back-link' : ''}`}
                        data-trusted-element="true"
                        data-option-index={index}
                        data-option-type={option.type}
                        disabled={isDisabled}
                    >
                        <span className="option-text" dangerouslySetInnerHTML={{ __html: option.text }} />
                        {hasDetails && (
                            <>
                                <span
                                    className="option-details-link"
                                    onClick={(e) => toggleOptionDetails(e, index)}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleOptionDetails(e, index); }}
                                >
                                    {isExpanded ? 'ver menos' : 'ver detalhes'}
                                </span>
                                {isExpanded && (
                                    <div
                                        className="option-details-content"
                                        dangerouslySetInnerHTML={{ __html: option.details }}
                                    />
                                )}
                            </>
                        )}
                    </button>
                );
            }
        };
        return (
            <>
                <div ref={containerRef} className={`message ${message.origin}`}>
                    <div className={`message-content`}>
                        {hasDetalhesPlaceholder ? (
                            <>
                                <div dangerouslySetInnerHTML={{ __html: responseBeforePlaceholder }} />
                                {showDetalhesOcultos && (
                                    <div className="detalhes-ocultos-content">
                                        {message.detalhesOcultos.map((item, idx) => (
                                            <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
                                        ))}
                                    </div>
                                )}
                                {responseAfterPlaceholder && (
                                    <div dangerouslySetInnerHTML={{ __html: responseAfterPlaceholder }} />
                                )}
                                <button
                                    className="ver-exames-btn"
                                    onClick={() => setShowDetalhesOcultos(prev => !prev)}
                                >
                                    {showDetalhesOcultos ? 'Ocultar detalhes' : 'Ver detalhes'}
                                </button>
                            </>
                        ) : (
                            <>
                                <div dangerouslySetInnerHTML={{
                                    __html: message.respostaExtensa || showAll || cleanedResponse.length <= 300
                                        ? cleanedResponse
                                        : cleanedResponse.substring(0, 269) + '...'
                                }} />
                                {!message.respostaExtensa && cleanedResponse.length > 300 && (
                                    <button
                                        className="show-more-btn"
                                        onClick={() => setShowAll(!showAll)}
                                    >
                                        <strong>{showAll ? 'Ver menos' : 'Ver mais'}</strong>
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                </div>
                <div className={`options-container${hasTimeButtons ? ' time-options' : ''}`}>
                    {visibleOptions.map(({ option, index }) => renderOption(option, index))}

                    {showPrevBtn && (
                        <button
                            className="option-button show-more-times-btn"
                            style={{ fontWeight: '500' }}
                            onClick={handlePrevOptions}
                            disabled={hasNewerButtonClicked || (selectedOption !== null)}
                        >
                            Ver anteriores
                        </button>
                    )}

                    {hasTimeButtons && nonSlotOptions.map(({ option, index }) => renderOption(option, index))}

                    {showMoreBtn && (
                        <button
                            className="option-button show-more-times-btn"
                            style={{ fontWeight: '500' }}
                            onClick={handleNextOptions}
                            disabled={hasNewerButtonClicked || (selectedOption !== null)}
                        >
                            {hasTimeButtons ? 'Ver mais horários' : 'Ver mais dias e horários'}
                        </button>
                    )}

                    {backButtons.map(({ option, index }) => renderOption(option, index))}
                </div>
                
                {hasTimeButtons && totalSlotPages > 1 && (
                    <div className="time-options-group-indicator">
                        Grupo {currentPage + 1} de {totalSlotPages}
                    </div>
                )}

                {(showButtonLink || showHomeLink) && (
                    <div className="button-link-wrapper">
                        {showButtonLink && (
                            <ButtonLink
                                text={message.buttonLinkText}
                                onClick={handleButtonLinkClick}
                            />
                        )}
                        {showHomeLink && (
                            <ButtonLink
                                text="Acessar menu inicial"
                                onClick={handleResetToHome}
                            />
                        )}
                    </div>
                )}
            </>
        );
    } else {

        if (message?.origin === 'bot') {

            // Se estiver "Digitando..." mas for uma mensagem que abre componente (ex.: pagamento),
            // não podemos retornar cedo, senão o componente não renderiza.
            if (message?.typing && message?.iniciarPagamento !== true) {
                const isConfirmando = message?.isConfirmandoAgendamento || 
                    (indexMessage > 0 && typeof arrayMessage[indexMessage - 1]?.response === 'string' && !!arrayMessage[indexMessage - 1]?.response.match(/confirmar.*agendamento/i));
                
                if (isConfirmando) {
                    return (
                        <div className={`message ${message?.origin}`} style={{ width: '100%' }}>
                            <div className="message-content" style={{ width: '100%', maxWidth: 'none', backgroundColor: 'transparent', boxShadow: 'none', border: 'none', padding: 0 }}>
                                <LoadingExames 
                                    phrases={["Confirmando o agendamento"]} 
                                    timeoutDuration={10000}
                                />
                            </div>
                        </div>
                    );
                }

                if (message?.isBuscaExamesLoading) {
                    return (
                        <div className={`message ${message?.origin}`} style={{ width: '100%' }}>
                            <div className="message-content" style={{ width: '100%', maxWidth: 'none', backgroundColor: 'transparent', boxShadow: 'none', border: 'none', padding: 0 }}>
                                <LoadingExames timeoutDuration={10000} />
                            </div>
                        </div>
                    );
                }

                if (message?.isBuscaExamesOcrLoading) {
                    return (
                        <div className={`message ${message?.origin}`} style={{ width: '100%' }}>
                            <div className="message-content" style={{ width: '100%', maxWidth: 'none', backgroundColor: 'transparent', boxShadow: 'none', border: 'none', padding: 0 }}>
                                <LoadingExames 
                                    phrases={["Enviando a imagem do pedido médico", "Agora, lendo o que foi solicitado"]} 
                                    timeoutDuration={5000}
                                />
                            </div>
                        </div>
                    );
                }

                if (message?.isOcrCarteirinhaLoading) {
                    return (
                        <div className={`message ${message?.origin}`} style={{ width: '100%' }}>
                            <div className="message-content" style={{ width: '100%', maxWidth: 'none', backgroundColor: 'transparent', boxShadow: 'none', border: 'none', padding: 0 }}>
                                <LoadingExames 
                                    phrases={["Estamos verificando os dados da carteirinha", "Quase lá! Otimizando a leitura de carteirinha"]} 
                                    timeoutDuration={5000}
                                />
                            </div>
                        </div>
                    );
                }

                return (
                    <div className={`message ${message?.origin}`}>
                        <div className={`message-content typing-indicator`}><div></div><div></div><div></div></div>
                    </div>
                );
            } else if (message?.error) {
                return (

                    <div className={`message ${message?.origin}`}>
                        <div className={`message-content`} dangerouslySetInnerHTML={{ __html: message.response }}></div>
                    </div>

                );

            } else if (message?.endSession) {
                return (

                    <div className={`message ${message?.origin}`}>
                        <div className={`message-content`} dangerouslySetInnerHTML={{ __html: message.response }}></div>
                    </div>

                );

            } else if (message?.carrossel && message?.carrossel.length > 0) {

                const formatUnidades = (message, imageUrl) => {

                    const unidadesFiltradas = message.carrossel.filter(unidade => !unidade.unidade.includes("[FECHADA]"));
                    const unidadesOrdenadas = unidadesFiltradas.sort((a, b) => a.distancia - b.distancia);
                    const unidadesMaisProximas = unidadesOrdenadas.slice(0, 3);

                    return unidadesMaisProximas.map(unidade => `
                        <div style="display: flex; align-items: center;">
                            <img src="${imageUrl}" alt="bullet" style="width: 40px; height: 40px; margin-right: 8px;" />
                            <h4>${unidade.unidade}</h4>
                        </div>
                        <br />
                        Endereço: ${unidade.endereco}, ${unidade.cidade}, ${unidade.estado}
                        <br />
                        <br />
                        Distancia: ${unidade.distancia.toFixed(2)} km
                        <br />
                        <br />
                    `).join('');
                };

                const formattedUnidades = formatUnidades(message, FlechaUnidades);

                return (

                    <div className={`message ${message?.origin}`}>
                        <div className={`message-content`} dangerouslySetInnerHTML={{ __html: formattedUnidades }}></div>
                    </div>

                );
                // return(
                //     <Carrossel message={message} />
                // )
            } else {


                return (
                    <div ref={containerRef} className={`message ${message?.origin}`}>
                        {/* Só mostra a mensagem se não há perguntas de apoio válidas ou se elas não foram completadas */}
                        {!(hasValidPerguntas(message.perguntasApoio) && perguntasCompletas) && (
                            <>
                                {message?.typing ? (
                                    (message?.isConfirmandoAgendamento || (indexMessage > 0 && typeof arrayMessage[indexMessage - 1]?.response === 'string' && !!arrayMessage[indexMessage - 1]?.response.match(/confirmar.*agendamento/i))) ? (
                                        <div className="message-content" style={{ width: '100%', maxWidth: 'none', backgroundColor: 'transparent', boxShadow: 'none', border: 'none', padding: 0 }}>
                                            <LoadingExames 
                                                phrases={["Confirmando o agendamento"]} 
                                                timeoutDuration={10000}
                                            />
                                        </div>
                                    ) : message?.isBuscaExamesLoading ? (
                                        <div className="message-content" style={{ width: '100%', maxWidth: 'none', backgroundColor: 'transparent', boxShadow: 'none', border: 'none', padding: 0 }}>
                                            <LoadingExames timeoutDuration={10000} />
                                        </div>
                                    ) : message?.isBuscaExamesOcrLoading ? (
                                        <div className="message-content" style={{ width: '100%', maxWidth: 'none', backgroundColor: 'transparent', boxShadow: 'none', border: 'none', padding: 0 }}>
                                            <LoadingExames 
                                                phrases={["Enviando a imagem do pedido médico", "Agora, lendo o que foi solicitado"]} 
                                                timeoutDuration={5000}
                                            />
                                        </div>
                                    ) : message?.isOcrCarteirinhaLoading ? (
                                        <div className="message-content" style={{ width: '100%', maxWidth: 'none', backgroundColor: 'transparent', boxShadow: 'none', border: 'none', padding: 0 }}>
                                            <LoadingExames 
                                                phrases={["Estamos verificando os dados da carteirinha", "Quase lá! Otimizando a leitura de carteirinha"]} 
                                                timeoutDuration={5000}
                                            />
                                        </div>
                                    ) : (
                                        <div className="message-content typing-indicator"><div></div><div></div><div></div></div>
                                    )
                                ) : (message?.pollingBindExams === true || message?.response === 'Estamos processando sua solicitação, aguarde um momento...') ? (
                                    <div className="message-content" style={{ width: '100%', maxWidth: 'none', backgroundColor: 'transparent', boxShadow: 'none', border: 'none', padding: 0 }}>
                                        <LoadingExames />
                                    </div>
                                ) : (
                                    <div className="message-content">
                                        {hasValidPerguntas(message.perguntasApoio) && !perguntasCompletas ? (
                                            <div dangerouslySetInnerHTML={{ __html: "Precisamos que responda algumas perguntas:" }} />
                                        ) : hasDetalhesPlaceholder ? (
                                            <>
                                                <div dangerouslySetInnerHTML={{ __html: responseBeforePlaceholder }} />
                                                {showDetalhesOcultos && (
                                                    <div className="detalhes-ocultos-content">
                                                        {message.detalhesOcultos.map((item, idx) => (
                                                            <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
                                                        ))}
                                                    </div>
                                                )}
                                                {responseAfterPlaceholder && (
                                                    <div dangerouslySetInnerHTML={{ __html: responseAfterPlaceholder }} />
                                                )}
                                                <button
                                                    className="ver-exames-btn"
                                                    onClick={() => setShowDetalhesOcultos(prev => !prev)}
                                                >
                                                    {showDetalhesOcultos ? 'Ocultar detalhes' : 'Ver detalhes'}
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                <div dangerouslySetInnerHTML={{
                                                    __html: message.respostaExtensa || showAll || cleanedResponse.length <= 300
                                                        ? cleanedResponse
                                                        : cleanedResponse.substring(0, 269) + '...'
                                                }} />
                                                {!message.respostaExtensa && cleanedResponse.length > 300 && (
                                                    <button
                                                        className="show-more-btn"
                                                        onClick={() => setShowAll(!showAll)}
                                                    >
                                                        <strong>{showAll ? 'Ver menos' : 'Ver mais'}</strong>
                                                    </button>
                                                )}
                                            </>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                        
                        {message?.retryOcrUpload && typeof requestImage === 'function' && (
                            <button
                                type="button"
                                className="ver-exames-btn"
                                onClick={() => requestImage(
                                    message.retryOcrUpload.requestId,
                                    message.retryOcrUpload.ocrType,
                                    message.retryOcrUpload.idPessoaFisica,
                                    message.retryOcrUpload.ocrProvider
                                )}
                            >
                                Reenviar documento
                            </button>
                        )}
                        {/* Upload do fornecedor: requer clique do usuário para abrir o seletor no navegador. */}
                        {message?.isWebhook && (message?.ocrCarteirinha || message?.ocrApenasPedidoMedico) && typeof requestImage === 'function' && (
                            <button
                                type="button"
                                className="ver-exames-btn"
                                onClick={() => requestImage(
                                    message.requisicaoAgendamento || requestId || null,
                                    message.ocrApenasPedidoMedico ? 'pedido-medico' : 'ocr-carteirinha',
                                    message.idPessoaFisica || null,
                                    message.providerKey === 'firstlayer' ? 'firstlayer' : 'fleury'
                                )}
                            >
                                Enviar {message.ocrApenasPedidoMedico ? 'pedido médico' : 'carteirinha'}
                            </button>
                        )}

                        {/* Componente de busca textual de exames */}
                        {message.buscaExamesTextual && (
                            <BuscaExames 
                                message={message}
                                handleButtonSetMessage={handleButtonSetMessage}
                                onSearchClick={(selectedExams) => {
                                    console.log('Exames selecionados:', selectedExams);
                                }}
                                client_id={client_id}
                                marca={marca || 'AM'}
                                origem={origem || 'chat-web'}
                                messages={messages || arrayMessage}
                                setMessages={setMessage}
                                localizacao={localizacao}
                                operational_system={operational_system || 'web'}
                                version_app={version_app || '1.0.0'}
                                buscaExamesMovel={message.buscaExamesMovel || false}
                                setRequestId={setRequestId}
                                requestImage={requestImage}
                                buttonLink={showButtonLink}
                                buttonLinkText={message?.buttonLinkText}
                                onButtonLinkClick={(text) => handleButtonSetMessage(text)}
                                showHomeLink={showHomeLink}
                            />
                        )}

                        {/* Componente de remoção de exames */}
                        {message.componenteRemocaoProcedimentos && (
                            <RemocaoExames 
                                message={message}
                                handleButtonSetMessage={handleButtonSetMessage}
                                client_id={client_id}
                                marca={marca || 'AM'}
                                origem={origem || 'chat-web'}
                                messages={messages || arrayMessage}
                                setMessages={setMessage}
                                localizacao={localizacao}
                                operational_system={operational_system || 'web'}
                                version_app={version_app || '1.0.0'}
                                setRequestId={setRequestId}
                                requestImage={requestImage}
                            />
                        )}

                        {/* Componente de perguntas de apoio - só aparece quando NÃO há remoção de exames E tem validacoes */}
                        {hasValidPerguntas(message.perguntasApoio) && !message.componenteRemocaoProcedimentos && (
                            <PerguntasApoio 
                                perguntasApoio={message.perguntasApoio}
                                onComplete={handlePerguntasApoioComplete}
                                client_id={client_id}
                                marca={marca || 'AM'}
                                origem={origem || 'chat-web'}
                                messages={messages || arrayMessage}
                                setMessages={setMessage}
                                localizacao={localizacao}
                                operational_system={operational_system || 'web'}
                                version_app={version_app || '1.0.0'}
                                isCompleted={perguntasCompletas}
                            />
                        )}

                        {/* Componente de Exames de Autorização */}
                        {Array.isArray(message.examesAutorizacao) && message.examesAutorizacao.length > 0 && (
                            <ExamesAutorizacao
                                exames={message.examesAutorizacao}
                                onComplete={handleExamesAutorizacaoComplete}
                                isCompleted={examesAutorizacaoCompletos}
                            />
                        )}

                        {/* Componente de convênio: flag pode vir no topo ou dentro de desativaFeedbackPorMensagem */}
                        {(message?.componenteConvenio === true || message?.desativaFeedbackPorMensagem?.componenteConvenio === true) && (
                            <Convenio 
                                onConfirm={handleConvenioConfirm}
                                onFastOcr={handleConvenioFastOCR}
                                onGoToParticular={handleConvenioGoToParticular}
                                isCompleted={convenioCompletado}
                                requestId={requestId}
                                defaultInsuranceId={message?.preselectedInsuranceId || ''}
                                forceManualFlow={message?.forceManualConvenioFlow === true}
                                examesSelecionados={resolvedExamesSelecionados}
                            />
                        )}

                        {/* Componente de pagamento: aberto automaticamente quando a API sinalizar iniciarPagamento */}
                        {message?.iniciarPagamento === true && (
                            <Pagamento
                                message={message}
                                client_id={client_id}
                                marca={marca || 'AM'}
                                origem={origem || 'chat-web'}
                                messages={messages || arrayMessage}
                                setMessages={setMessage}
                                localizacao={localizacao}
                                operational_system={operational_system || 'web'}
                                version_app={version_app || '1.0.0'}
                                requestId={requestId}
                                setRequestId={setRequestId}
                                requestImage={requestImage}
                            />
                        )}

                        {/* Button-link genérico (quando não há componente especial que o use internamente) */}
                        {!message.buscaExamesTextual && (showButtonLink || showHomeLink) && (
                                <div className="button-link-wrapper">
                                    {showButtonLink && (
                                        <ButtonLink
                                            text={message.buttonLinkText}
                                            onClick={handleButtonLinkClick}
                                        />
                                    )}
                                    {showHomeLink && (
                                        <ButtonLink
                                            text="Acessar menu inicial"
                                            onClick={handleResetToHome}
                                        />
                                    )}
                                </div>
                        )}
                        
                        {/* Feedback só aparece quando a flag desativaFeedbackPorMensagem for false/undefined (suporta objeto ou boolean) */}
                        {(() => {
                            const isFeedbackDisabled = typeof message?.desativaFeedbackPorMensagem === 'object'
                                ? message?.desativaFeedbackPorMensagem?.desativaFeedbackPorMensagem === true
                                : message?.desativaFeedbackPorMensagem === true;
                            return !isFeedbackDisabled && !message.isFirstMessage && !message.buscaExamesTextual && !hasValidPerguntas(message.perguntasApoio);
                        })() && (
                            <Feedback 
                                index={indexMessage} 
                                message={arrayMessage} 
                                uuid={uuidMessage} 
                                clientID={client_id} 
                                setMessages={setMessage} 
                            />
                        )}
                    </div>
                );
            }
        } else {
            return (

                <div ref={containerRef} className={`message ${message?.origin}`}>
                    <div className={`message-content`} dangerouslySetInnerHTML={{ __html: message.response }} />
                </div>

            );
        }

    }
};

export default ChatMessage;
